<template>
  <div class="container-lg">
    <div
      class="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-x-4 gap-y-4 sm:gap-x-8 lg:gap-x-4 mt-8 sm:mt-16 md:mt-20"
    >
      <article
        v-for="plot in visible"
        :key="plot.id"
        class="flex flex-col text-center border border-green pb-4"
      >
        <div
          :class="[
            plot.status === 'ledig' ? 'bg-green' : 'bg-gray-500',
            'text-center py-3 leading-tight'
          ]"
        >
          <h3 class="text-white uppercase font-bold text-2xl">
            {{ plot.post_title }}
          </h3>
        </div>
        <div v-html="plot.image"></div>
        <div class="mt-3">Størrelse: {{ plot.size }}m2</div>
        <div class="mt-3 uppercase">{{ plot.status }}</div>
        <div class="flex justify-center mt-3">
          <a :href="plot.permalink" class="btn btn--green">LES MER</a>
        </div>
      </article>
    </div>
    <div
      class="flex sm:justify-center mt-10 sm:mt-16"
      v-if="view <= plots.length"
    >
      <button class="btn btn--green mt-4 uppercase" @click="viewMore">
        Se flere
      </button>
    </div>
  </div>
</template>

<script>
const initialNumber = 8;
export default {
  props: {
    plots: {
      type: Array,
      required: true,
      default: []
    }
  },
  data() {
    return {
      view: initialNumber,
      visible: this.plots.slice(0, initialNumber)
    };
  },
  methods: {
    viewMore() {
      this.view = this.view + initialNumber;
      this.visible = this.plots.slice(0, this.view);
    }
  }
};
</script>
